export const OUTLETS = 'OUTLETS'
export const SET_OUTLET = 'SET_OUTLET'
export const SET_OUTLETS = 'SET_OUTLETS'
